import { HypothekenState } from "./hypotheek-types";

export function isHuidig(hypotheek: HypothekenState): boolean {
  return hypotheek.producten.every(x => x.hypotheekProductDetails !== null);
}

export function isVoorstel(hypotheek: HypothekenState): boolean {
  return hypotheek.producten.every(x => x.hypotheekProductDetails === null);
}
